import { type ArenaGroup } from "~/graphql/supergraphTypes";
import { ArenaGroupDisplayInfo } from "./types";

/**
 * Determines the display text and variant for the arena groups.
 *
 * @param {ArenaGroup[]} arenaGroups - The array of arena groups.
 * @returns {ArenaGroupDisplayInfo} The display text and variant for the arena groups.
 */
export const getArenaGroupsDisplayInfo = (arenaGroups: ArenaGroup[]): ArenaGroupDisplayInfo => {
  const hasFAOnly = arenaGroups.includes("FA_ONLY");
  const hasNonFAOnly = arenaGroups.includes("NON_FA_ONLY");
  const hasTestArenaOnly = arenaGroups.includes("TEST_ARENA_ONLY");

  if (hasFAOnly && hasNonFAOnly) {
    return { text: "All arenas", variant: "success" };
  }

  if (hasFAOnly) {
    return { text: "FA Only", variant: "warning" };
  }

  if (hasNonFAOnly) {
    return { text: "Non-FA Only", variant: "primary" };
  }

  if (hasTestArenaOnly) {
    return { text: "Test Arena Only", variant: "informative" };
  }

  return { text: "Unknown", variant: "neutral" };
};
